export const MenuTabId = "sidebar-menu";
